<section class="wrapper-container">
  <app-identity-verification
    [email]="email()"
    [guestId]="guestId()"
    [initialStep]="initialStep()"
    (completed)="onCompleted()"
    (canceled)="onCanceled()"
    (limitReached)="onLimitReached()"
  ></app-identity-verification>
</section>
